<div class="" *ngIf="isUserLogin">
    <loading-contents *ngIf="users == null"></loading-contents>
    <div class="main-contents" *ngIf="users != null">
        <div class="dashborad padding-top-30">
            <div class="container">
                <dashboard-header></dashboard-header>
                <div class="row" *ngIf="users">
                    <div class="col-lg-12 padding-bottom-15">
                        <h5>Users ({{total}})</h5>
                    </div>
                    <div class="col-lg-3 col-xs-6 col-md-3 col-sm-6 padding-bottom-30" *ngFor="let item of users">
                        <div class="card">
                            <div class="card-contents">
                                <p><span class="bold">Name: </span>{{item.name}}</p>
                                <p><span class="bold">email: </span>{{item.email}}</p>
                                <p *ngIf="item.active == 1"><span class="bold">Status: </span>Active</p>
                                <p *ngIf="item.active == 0"><span class="bold">Status: </span>Inactive</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-6 col-xs-6 col-md-6 col-sm-6">
                                <button class="btn btn-outline-light btn-sm" type="button" data-toggle="modal" attr.data-target="#update-item-{{item.id}}" (click)="onEdit(item)">Edit</button>
                                <!-- Modal -->
                                <div class="modal fade" id=update-item-{{item.id}} tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                                    <div class="modal-dialog modal-dialog-centered" role="document">
                                    <div class="modal-content">
                                        <form [formGroup]="registerForm" autocomplete="off" >
                                            <div class="modal-header">
                                                <h5 class="modal-title" id="centerTitle">Update User</h5>
                                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div class="modal-body">
                                                <p>Are your sure you want to update this user?</p>
                                                <div class="form-group d-none">
                                                    <label>Id:</label>
                                                    <input type="number" formControlName="id" name="id" class="form-control" attr.value="{{item.id}}">
                                                </div>
                                                <div class="form-group">
                                                    <label for="name">Name:</label>
                                                    <input type="text" name="name" formControlName="name" class="form-control input-sm">
                                                </div>
                                                <div class="alert alert-danger" *ngIf="registerForm.get('name').hasError('required') && registerForm.get('name').touched">
                                                    Please enter your name.
                                                </div>
                                                <div class="form-group">
                                                    <label for="email">Email:</label>
                                                    <input type="email" name="email" formControlName="email" class="form-control input-sm">
                                                </div>
                                                <div class="alert alert-danger" *ngIf="registerForm.get('email').hasError('required') && registerForm.get('email').touched">
                                                    Please enter email.
                                                </div>
                                                <div class="alert alert-danger" *ngIf="registerForm.get('email').hasError('maxlength') && registerForm.get('email').touched">
                                                    Maximum 30 characters are allowed.
                                                </div>
                                                <div class="alert alert-danger" *ngIf="registerForm.get('email').hasError('pattern') && registerForm.get('email').touched">
                                                Please enter the correct email format.
                                                </div>
                                                <div class="form-group">
                                                    <label for="active">Active status: (0: inactive, 1: active)</label>
                                                    <input type="text" name="active" formControlName="active" class="form-control input-sm">
                                                </div>
                                                <div class="alert alert-danger" *ngIf="registerForm.get('active').hasError('required') && registerForm.get('active').touched">
                                                    Please enter Active status.
                                                </div>
                                                <div class="alert alert-danger" *ngIf="registerForm.get('active').hasError('pattern')">
                                                    Active status doesn't macth the pattern.
                                                </div>
                                            </div>
                                            <div class="modal-footer">
                                                <div class="row">
                                                    <div class="buttons col-lg-6">
                                                        <button type="button" class="btn btn-outline-danger" data-dismiss="modal" [disabled]="registerForm.invalid" (click)="editItem()">Yes</button>
                                                    </div>
                                                    <div class="buttons col-lg-6">
                                                        <button type="button" class="btn btn-outline-light" data-dismiss="modal">Cancel</button>
                                                    </div>                                               
                                                </div>                                        
                                            </div>
                                        </form>
                                    </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-xs-6 col-md-6 col-sm-6">
                                <button class="btn btn-outline-danger btn-sm" type="button" data-toggle="modal" attr.data-target="#delete-item-{{item.id}}">Delete</button>
                                <!-- Modal -->
                                <div class="modal fade" id=delete-item-{{item.id}} tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                                    <div class="modal-dialog modal-dialog-centered" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                        <h5 class="modal-title" id="centerTitle">Delete Message</h5>
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                        </div>
                                        <div class="modal-body">
                                            <p>Are your sure you want to permanently remove this user?</p>
                                        </div>
                                        <div class="modal-footer">
                                            <div class="row">
                                                <div class="buttons col-lg-6">
                                                    <button type="button" class="btn btn-outline-danger" data-dismiss="modal" (click)="deleteItem(item)">Yes</button>
                                                </div>
                                                <div class="buttons col-lg-6">
                                                    <button type="button" class="btn btn-outline-light" data-dismiss="modal">Cancel</button>
                                                </div>                                               
                                            </div>                                        
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="" *ngIf="!isUserLogin">
    <app-slider></app-slider>
    <div class="loading">
        <div class="wrapper padding-top-30">
            <div class="container">
                <p>Oops, The page you are looking for can't be found!</p>
                <div class="missing-page">
                    <span class="side">4</span>
                    <span class="taiji-icon"></span>
                    <span class="side">4</span>
                </div>
                <p>Loading...</p>
            </div>
        </div>
    </div>
    <div class="socail-media padding-top-30">
        <div class="container">
            <div class="row">
                <div class="col-lg-6 col-xs-6 col-md-6 col-sm-6">
                    <instagram-post></instagram-post>
                </div>
                <div class="col-lg-6 col-xs-6 col-md-6 col-sm-6">
                    <tumblr-posts></tumblr-posts>
                </div>
            </div>
        </div>
    </div>
</div>
